/**
 * 🎶 Display names for space-command verbs — the ONE reader for rendering a
 * stored command name (the utils/playerKind.js pattern: identity questions get
 * one answer site).
 *
 * Why this exists: /jukebox was renamed to /aux on 2026-08-17 (Nina: the aux
 * is the fiction everywhere else — "grabbed the aux" cards, house_aux, the
 * guest grab). The INTERNAL id stays 'jukebox' on purpose:
 *   · every stored action row (old AND new) says command:'jukebox', so the
 *     database keeps exactly one name forever;
 *   · the locals' impulse lane and hostEnactment look specs up by the literal
 *     kind 'jukebox' and write rows directly — renaming the id breaks them.
 * So renames happen HERE, at render time, and nowhere else. Full contract:
 * AUX_COMMAND_RENAME_2026_08_17.md.
 *
 * ⚠️ 'jukebox' is ALSO the name of two unrelated things — the chibi explorer
 * show's opener song (AdminPage "Jukebox house song", /admin/explorer/jukebox)
 * and the explorer viewer's postMessage protocol. Those are NOT this command
 * and must never be renamed by an aux sweep.
 */
const COMMAND_DISPLAY_NAMES = { jukebox: 'aux' };

// 🕯️ Room verbs (ROOM_VERBS_PEEK_SPEC §3): stored under a namespaced internal
// id ('rv_knock') so they can never collide with the residents' impulse kinds
// (`water`, `nap`, `borrow` resolve through the same backend registry). Same
// doctrine as aux: the id is forever, the rename happens HERE.
const ROOM_VERB_ID_PREFIX = 'rv_';

// 🦝🧦 The house's own cards that nobody can type (09-24, lost & found): a
// "/house_missing" header would read as a command. Words, no slash.
// 📚 the House library's open-wake card (houseBooks WAKE_COMMAND 'book_open', W3): the
// library's residents react to a book being opened; its header names the room, never "/book_open"
const HOUSE_CARD_HEADERS = { house_missing: 'lost & found', house_found: 'lost & found', book_open: 'the library' };
export function houseCardHeader(command) {
  return HOUSE_CARD_HEADERS[command] || null;
}

export function displayCommandName(command) {
  if (typeof command === 'string' && command.startsWith(ROOM_VERB_ID_PREFIX)) {
    return command.slice(ROOM_VERB_ID_PREFIX.length);
  }
  return COMMAND_DISPLAY_NAMES[command] || command;
}

export default displayCommandName;
